import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col justify-center overflow-hidden" data-id="element-75">
      {/* Background Image with Gradient Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-76">
        <img src="https://cdn.magicpatterns.com/uploads/bxzLiZV2Jtj2XGQN8mD5iv/PORTADAOFICIAL7NochesParaVolver.png" alt="Pareja en momento íntimo" className="w-full h-full object-cover object-center" data-id="element-77" />
        <div className="absolute inset-0 bg-gradient-to-b from-wine-dark/80 via-wine/60 to-cream" data-id="element-78"></div>
      </div>

      <div className="relative z-10 container mx-auto px-6 py-20 md:py-32 max-w-4xl text-center" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-80">
          <span className="inline-block py-1 px-3 rounded-full bg-amber/20 text-amber-light border border-amber/30 text-sm font-medium mb-6 backdrop-blur-sm" data-id="element-81">
            Para parejas que se quieren pero se traban
          </span>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-lg" data-id="element-82">
            7 noches para volver a tocarse…{' '}
            <span className="italic font-light text-amber-light" data-id="element-83">
              sin pasar vergüenza
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-cream-dark/90 mb-12 font-light max-w-2xl mx-auto leading-relaxed" data-id="element-84">
            Una guía romántica de 7 días para parejas que se quieren pero se
            traban.
          </p>

          <div className="bg-white/10 backdrop-blur-md rounded-xl p-8 md:p-10 border border-white/20 shadow-2xl max-w-3xl mx-auto text-left" data-id="element-85">
            <p className="text-lg md:text-xl text-white leading-relaxed font-serif italic" data-id="element-86">
              "No es que no lo ames. No es que ya no te guste. Es que{' '}
              <strong className="text-amber-light font-bold not-italic" data-id="element-87">
                te da pena
              </strong>
              .
              <br data-id="element-88" />
              <br data-id="element-89" />
              Pena de iniciar. Pena de que te diga “hoy no”. Pena de sentirte
              intenso/a, needy, o de “hacer el ridículo”.
              <br data-id="element-90" />
              <br data-id="element-91" />Y entonces haces lo que casi todos hacen: te quedas
              quieto/a… esperando que el momento se arregle solo."
            </p>
          </div>

          <div className="mt-12" data-id="element-92">
            <a href="#pricing" className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-wine-dark bg-amber hover:bg-amber-light transition-all duration-300 rounded-full shadow-lg hover:shadow-amber/50 transform hover:-translate-y-1" data-id="element-93">
              Quiero empezar hoy
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-94" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}